@let animation = currentAnimation();
@if (isVisible() && animation) {
	<div
		class="overlay tutorial__overlay"
		(swipeleft)="switchAnimation(1)"
		(swiperight)="switchAnimation(-1)"
	>
		<div class="tutorial__top">
			<p class="tutorial__title">{{ animation.title }}</p>
			<p class="tutorial__message">{{ animation.message }}</p>
		</div>
		<ng-lottie
			class="tutorial__animation"
			[options]="animation.options"
		></ng-lottie>
		<div class="tutorial__bottom">
			<div class="tutorial__dots">
				@for (item of animations(); track item; let index = $index) {
					<div
						class="tutorial__dot"
						[class.tutorial__dot_active]="index === currentAnimationIndex()"
					></div>
				}
			</div>
			<div class="tutorial__actions">
				<button
					type="button"
					class="tutorial__button"
					[class]="isLastSlide() ? 'primary' : 'secondary'"
					(click)="closeTutorial()"
				>
					Close Tutorial
				</button>
				@if (!isLastSlide()) {
					<button
						type="button"
						class="primary tutorial__button"
						(click)="switchAnimation(1)"
					>
						Next
					</button>
				}
			</div>
		</div>
	</div>
}
